module.exports = __webpack_public_path__ + "static/warforged-2-81685fef03d2b094736d97638e69af46.png";